import React from 'react';
import Select from '@/components/ui/Select';
import FormItem from '@/components/ui/FormItem';
import { useLine } from '@/components/views/Resolution886/components/Form/_hooks';
import type { FormItemProps } from '@/components/views/Resolution886/types';

interface LineFormItemProps extends FormItemProps {
	fieldName?: string | string[];
}

export function LineFormItem({ required = true, labelCol, fieldName }: LineFormItemProps): JSX.Element {
	const { items, isFetching, isDisabled, lineId, handleClearLines, handleSelectLine } = useLine({ fieldName });

	return (
		<FormItem
			label="Line"
			name={fieldName}
			requiredMessage="Please select a line"
			required={required}
			labelCol={labelCol}
		>
			<Select
				allowClear
				value={lineId}
				options={items}
				loading={isFetching}
				disabled={isDisabled}
				onClear={handleClearLines}
				onChange={handleSelectLine}
				placeholder="Select a line"
			/>
		</FormItem>
	);
}
